import { BaseEntity } from '../../../base/BaseEntity';
export class Schedule  extends BaseEntity  {
    /**
     *
     */
    constructor() {
        super();
        this.monday = false;
        this.tuesday = false;
        this.wednesday = false;
        this.thursday = false;
        this.friday = false;
        this.saturday = false;
        this.sunday = false;
        this.holiday = false;        
    }
    scheduleTypeId:string;
    fromTime:string;
    tillTime:string;
    monday:boolean;
    tuesday:boolean;
    wednesday:boolean;
    thursday:boolean;
    friday:boolean;
    saturday:boolean;
    sunday:boolean;
    holiday:boolean;
}
